const AU_STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];

const UK_POSTCODE_RE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;

export function getAuStates() {
  return AU_STATES;
}

export function normalizeAddressFields(fields) {
  const country = (fields.country || "").trim().toUpperCase();
  let postcode = (fields.postcode || "").trim();
  let state = (fields.state || "").trim();

  if (country === "AU" || country === "NZ") {
    postcode = postcode.replace(/\D/g, "").slice(0, 4);
  }
  if (country === "AU") {
    state = state.toUpperCase();
  }
  if (country === "US") {
    state = state.toUpperCase().slice(0, 2);
  }

  return {
    address: (fields.address || "").trim().replace(/\s+/g, " "),
    suburb: (fields.suburb || "").trim().replace(/\s+/g, " "),
    postcode,
    state,
    country,
  };
}

export function formatAddressLines(fields) {
  const data = normalizeAddressFields(fields);
  const lines = [];

  if (data.address) lines.push(data.address);

  const locality = [data.suburb, data.state, data.postcode].filter(Boolean).join(" ");
  if (locality) lines.push(locality);

  if (data.country) {
    const countryName = countryLabel(data.country);
    lines.push(countryName || data.country);
  }

  return lines;
}

export function countryLabel(code) {
  const labels = {
    AU: "Australia",
    NZ: "New Zealand",
    US: "United States",
    GB: "United Kingdom",
    CA: "Canada",
  };
  return labels[code] || code;
}

export function validateShippingAddress(fields) {
  const data = normalizeAddressFields(fields);
  const errors = {};

  if (!data.address || data.address.length < 5) {
    errors.address =
      "Enter your full street address including the street number (e.g. 12 Example Street).";
  } else if (data.address.length > 200) {
    errors.address = "Address is too long.";
  } else if (/^p\.?\s*o\.?\s*box/i.test(data.address)) {
    errors.address = "We cannot ship to PO boxes. Use a street address.";
  }

  if (!data.suburb || data.suburb.length < 2) {
    errors.suburb = "Enter a valid suburb or city.";
  } else if (data.suburb.length > 80) {
    errors.suburb = "Suburb or city name is too long.";
  }

  if (!data.country) {
    errors.country = "Select a country.";
  }

  if (data.country === "AU") {
    if (!/^\d{4}$/.test(data.postcode)) {
      errors.postcode = "Australian postcodes must be exactly 4 digits.";
    }
    if (!AU_STATES.includes(data.state)) {
      errors.state = "Select your state or territory.";
    }
  } else if (data.country === "NZ") {
    if (!/^\d{4}$/.test(data.postcode)) {
      errors.postcode = "New Zealand postcodes must be exactly 4 digits.";
    }
    if (!data.state || data.state.length < 2) {
      errors.state = "Enter your region or territory.";
    }
  } else if (data.country === "US") {
    if (!/^\d{5}(-\d{4})?$/.test(data.postcode)) {
      errors.postcode = "Enter a valid ZIP code (e.g. 90210 or 90210-1234).";
    }
    if (!/^[A-Z]{2}$/.test(data.state)) {
      errors.state = "Use the 2-letter state code (e.g. CA, NY).";
    }
  } else if (data.country === "GB") {
    if (!UK_POSTCODE_RE.test(data.postcode.replace(/\s+/g, ""))) {
      errors.postcode = "Enter a valid UK postcode (e.g. SW1A 1AA).";
    }
    if (!data.state || data.state.length < 2) {
      errors.state = "Enter your county or city.";
    }
  } else if (data.country) {
    if (!data.postcode || data.postcode.length < 3) {
      errors.postcode = "Enter a valid postcode.";
    }
    if (!data.state || data.state.length < 2) {
      errors.state = "Enter your state, province, or region.";
    }
  }

  return {
    ok: Object.keys(errors).length === 0,
    errors,
    data,
  };
}

export function isAddressComplete(fields) {
  return validateShippingAddress(fields).ok;
}
